import { Address } from 'olo-service/models';

const GoogleComponent = {
  streetNum: 'street_number',
  street: 'route',
  city: 'locality',
  state: 'administrative_area_level_1',
  zip: 'postal_code',
  zipSuffix: 'postal_code_suffix',
  country: 'country',

  // City could potentially be one of the below if not locality
  sublocality: 'sublocality',
  sublocality_level_1: 'sublocality_level_1',
  sublocality_level_2: 'sublocality_level_2',
  sublocality_level_3: 'sublocality_level_3',
  sublocality_level_4: 'sublocality_level_4',
};

export function addressComponentsToAddress(addressComponents: google.maps.GeocoderAddressComponent[]): Address | null {
  const componentMap: Map<string, string> = createAddressComponentMap(addressComponents);

  let address1: string | undefined;
  if (componentMap.has(GoogleComponent.streetNum) && componentMap.has(GoogleComponent.street)) {
    address1 = `${componentMap.get(GoogleComponent.streetNum)} ${componentMap.get(GoogleComponent.street)}`;
  } else if (componentMap.has(GoogleComponent.street)) {
    address1 = componentMap.get(GoogleComponent.street);
  }

  let zip: string | undefined;
  if (componentMap.has(GoogleComponent.zip) && componentMap.has(GoogleComponent.zipSuffix)) {
    zip = `${componentMap.get(GoogleComponent.zip)}-${componentMap.get(GoogleComponent.zipSuffix)}`;
  } else if (componentMap.has(GoogleComponent.zip)) {
    zip = componentMap.get(GoogleComponent.zip);
  }

  const city = parseCity(componentMap);
  const state = componentMap.get(GoogleComponent.state);
  const country = componentMap.get(GoogleComponent.country);

  // check if all fields are not undefined
  if (address1 == null || city == null || state == null || country == null || zip == null) {
    return null;
  }

  return {
    address1,
    city,
    state,
    zip,
    country,
  };
}

const CITY_GOOGLE_COMPONENT_PRIORITY = [
  GoogleComponent.city,
  GoogleComponent.sublocality,
  GoogleComponent.sublocality_level_1,
  GoogleComponent.sublocality_level_2,
  GoogleComponent.sublocality_level_3,
  GoogleComponent.sublocality_level_4,
];

function parseCity(componentMap: Map<string, string>): string | undefined {
  let city: string | undefined;
  for (const cityKey of CITY_GOOGLE_COMPONENT_PRIORITY) {
    if (componentMap.has(cityKey)) {
      city = componentMap.get(cityKey);
      break;
    }
  }

  return city;
}

function createAddressComponentMap(addressComponents: google.maps.GeocoderAddressComponent[]) {
  const componentMap: Map<string, string> = new Map();

  addressComponents.forEach((component) => {
    if (component.types.includes(GoogleComponent.streetNum)) {
      componentMap.set(GoogleComponent.streetNum, component.long_name);
    } else if (component.types.includes(GoogleComponent.street)) {
      componentMap.set(GoogleComponent.street, component.long_name);
    } else if (component.types.includes(GoogleComponent.state)) {
      componentMap.set(GoogleComponent.state, component.short_name);
    } else if (component.types.includes(GoogleComponent.zip)) {
      componentMap.set(GoogleComponent.zip, component.long_name);
    } else if (component.types.includes(GoogleComponent.zipSuffix)) {
      componentMap.set(GoogleComponent.zipSuffix, component.long_name);
    } else if (component.types.includes(GoogleComponent.country)) {
      componentMap.set(GoogleComponent.country, component.short_name);
    } else if (component.types.includes(GoogleComponent.city)) {
      componentMap.set(GoogleComponent.city, component.long_name);
    } else if (component.types.includes(GoogleComponent.sublocality)) {
      componentMap.set(GoogleComponent.sublocality, component.long_name);
    } else if (component.types.includes(GoogleComponent.sublocality_level_1)) {
      componentMap.set(GoogleComponent.sublocality_level_1, component.long_name);
    } else if (component.types.includes(GoogleComponent.sublocality_level_2)) {
      componentMap.set(GoogleComponent.sublocality_level_2, component.long_name);
    } else if (component.types.includes(GoogleComponent.sublocality_level_3)) {
      componentMap.set(GoogleComponent.sublocality_level_3, component.long_name);
    } else if (component.types.includes(GoogleComponent.sublocality_level_4)) {
      componentMap.set(GoogleComponent.sublocality_level_4, component.long_name);
    }
  });

  return componentMap;
}
